const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/offers/$id/price.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { generateOfferMeta } from "@/lib/generate-offer-meta";
import { offerOnlyQueryOptions } from "@/queries/offer-gql";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/lib/i18n";
export const Route = createFileRoute("/{-$locale}/offers/$id/price")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    params,
    context
  }) => {
    const {
      id
    } = params;
    const {
      queryClient,
      locale
    } = context;
    const offer = await queryClient.ensureQueryData(offerOnlyQueryOptions(id, locale));
    return {
      id,
      dehydratedState: dehydrate(queryClient),
      offer
    };
  },
  head: ctx => {
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("offerDetail.common.offerNotFound"),
          description: i18n.t("offerDetail.common.offerNotFound")
        }]
      };
    }
    const {
      offer
    } = ctx.loaderData;
    if (!offer) {
      return {
        meta: [{
          title: i18n.t("offerDetail.common.offerNotFound"),
          description: i18n.t("offerDetail.common.offerNotFound")
        }]
      };
    }
    return {
      meta: generateOfferMeta(offer, i18n.t("offerDetail.price.title"))
    };
  }
});